import { graphqlApolloClient } from "../graphql-apollo-client"
import { UPDATE_RISK_MANAGEMENT_FOR_TECHNICAL_MONITORING }
  from "./graphql/mutations/updateRiskManagementForTechnicalMonitoring"

export const editRiskForTechnicalMonitoring = async (id, riskData) => {
  const { data: responseData } = await graphqlApolloClient.mutate({
    mutation: UPDATE_RISK_MANAGEMENT_FOR_TECHNICAL_MONITORING,
    variables: {
      id: id,
      riskData
    }
  })

  return responseData?.UpdateRiskManagementForTechnicalMonitoring
}